import { Chip } from '@/global/components/Chip'
import { GridCellParams } from '@/global/components/DataGrid/utils/types'
import { StatusAprovacao } from '@acme/core'

export function Status(params: GridCellParams) {
    let { statusAprovacao } = params.row
    if (statusAprovacao === undefined)
        statusAprovacao = StatusAprovacao.APROVADO

    let label = String(statusAprovacao)
    if (statusAprovacao === StatusAprovacao.PENDENTE_EXCLUSAO) {
        label = 'EXCLUSÃO PENDENTE'
    }

    return (
        <Chip
            label={label}
            color={
                statusAprovacao === StatusAprovacao.APROVADO
                    ? 'success'
                    : statusAprovacao === StatusAprovacao.REPROVADO
                      ? 'error'
                      : 'warning'
            }
        />
    )
}
